import { dashboard } from './dashboard';
import { settings } from './settings';

//-----------------------|| MENU ITEMS ||-----------------------//

const menuItems = {
    items: [
        dashboard,
        settings,
    ]
};

export default menuItems;
